var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130.4 130.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M101.4,128.1c-24.2,0-49.2-11.1-68.6-30.5l-0.4-0.4l0,0C12.3,76.9,1.3,51.4,1.9,26.8l0-1.8l1.1-1.4 c1.7-2.2,3.5-4.2,5.3-6c6.6-6.6,14.3-11.6,23-15C32.4,2.2,33.6,2,34.9,2c2.9,0,9.5,1.5,11.2,6.1c3,8.2,6.7,19,9.4,29.2 c0.8,2.9,0,9.9-4,12.4l-9.6,6.1c0.1,0.1,0,1.6,1.3,3.3c3.7,5.1,8,10.2,12.8,15c4.8,4.7,9.9,9,14.9,12.7c1,0.7,2.1,1.1,3,1.1 l3.3-4.6l3.1-4.8c2.7-4.1,9.3-4.2,10.1-4.2c0.8,0,1.5,0.1,2.1,0.2c12.6,2.8,20.2,5.2,29.8,9.6c4.3,1.9,7,9.7,5.1,14.6 c-3.3,8.7-8.4,16.4-15,23c-1.9,1.9-3.9,3.6-6,5.3l-1.4,1.1L101.4,128.1L101.4,128.1z M12.7,28.9c0.1,21,10.2,43.5,27.4,60.7 l0.5,0.5c17.2,17.2,39.3,27.1,60.5,27.2c1.3-1.1,2.5-2.2,3.6-3.3c5.5-5.5,9.7-12,12.5-19.2c-0.1,0-0.3-0.7-0.5-1.2 c-8.4-3.7-15.3-5.9-26.7-8.5c-0.3,0-0.8,0.1-1.3,0.3l-5.5,8.6c-3.4,5.5-12.4,6.4-18.9,1.6c-5.5-4-10.9-8.6-16.2-13.8 c-5.2-5.3-9.9-10.8-13.9-16.3c-2.7-3.6-3.7-8-3-11.9c0.6-3,2.3-5.5,4.7-7l8.6-5.4c0.1-0.5,0.2-1.2,0.2-1.5 c-2.4-8.9-5.8-18.7-8.6-26.5c-0.5-0.2-1.1-0.3-1.5-0.3C28,15.5,21.5,19.8,16,25.3C14.9,26.4,13.8,27.6,12.7,28.9L12.7,28.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.a88336a5ffa7afb8e7a98da1432d1179.svg";
export { ForwardRef as ReactComponent };